export interface BuildEnv {
  envName: string;
  commitSha: string;
  buildTimestamp: string;
}

function readEnv(name: string, fallback: string): string {
  const value = import.meta.env[name];
  if (typeof value === 'string' && value.length > 0) return value;
  return fallback;
}

export function getBuildEnv(): BuildEnv {
  return {
    envName: readEnv('VITE_ENV_NAME', 'local'),
    commitSha: readEnv('VITE_COMMIT_SHA', 'unknown'),
    buildTimestamp: readEnv('VITE_BUILD_TIMESTAMP', 'unknown'),
  };
}
